import { render, staticRenderFns } from "./CreateTalks.vue?vue&type=template&id=1f314cb9&"
import script from "./CreateTalks.vue?vue&type=script&lang=js&"
export * from "./CreateTalks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports